/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Chat_3Inputs */



/**
* | output |
* | --- |
* | "Justus' onboarding guide" |
*
* @param {Sidebar_Preview_Chat_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_chat_3 = /** @type {((inputs?: Sidebar_Preview_Chat_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Chat_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Justus' Onboarding-Leitfaden")
	return /** @type {LocalizedString} */ ("Justus' onboarding guide")
});